export const markerContent = (marker) => {
    const title = marker.title
    const content = marker.content
    const city = marker.city

    return /*html*/ `
    <div class="marker-inner p-12 mw-220">
        <h4 class=""><strong>${title}</strong></h4>
        ${content}
        <div class="city d-flex align-items-center mt-8">
            <span class="material-icons-round me-8">place</span>
            ${city}
        </div>
    </div>
`
}
